import { render, staticRenderFns } from "./UploadProductThumbnails.vue?vue&type=template&id=03cbcfc0&scoped=true&"
import script from "./UploadProductThumbnails.vue?vue&type=script&lang=js&"
export * from "./UploadProductThumbnails.vue?vue&type=script&lang=js&"
import style0 from "./UploadProductThumbnails.vue?vue&type=style&index=0&id=03cbcfc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cbcfc0",
  null
  
)

export default component.exports